import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import PublicSite from "./pages/PublicSite";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AccessPage from "./pages/AccessPage";
import { PaymentSuccess, PaymentCancel } from "./pages/PaymentResult";
import ErrorBoundary from "./pages/admin/ErrorBoundary";
import { useAuth } from "./store/auth";

const Protected = ({ children }) => {
  const { token, ready, user, init } = useAuth();
  useEffect(() => { if (!ready) init(); }, [ready, init]);
  if (!ready) return <div className="min-h-screen bg-black" />;
  if (!token || !user) return <Navigate to="/admin/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App dark">
      <Toaster theme="dark" position="top-right" />
      <BrowserRouter>
        <ErrorBoundary fullPage>
        <Routes>
          <Route path="/" element={<PublicSite />} />
          <Route path="/access" element={<AccessPage />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Protected><AdminDashboard /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </ErrorBoundary>
      </BrowserRouter>
    </div>
  );
}

export default App;
